<ng-container>
  <xux-expand-collapse-icon
    *ngIf="
      formConfig?.expandIconConfig &&
      !(isFormExpanded(formConfig.formKey) | async)
    "
    [iconConfig]="formConfig?.expandIconConfig"
    [collapsed]="!(isFormExpanded(formConfig?.formKey) | async)"
    (onCollapsed)="expandRightContent($event, formConfig?.formKey)"
    [attr.data-form-key]="formConfig?.formKey"
  ></xux-expand-collapse-icon>
  <ng-template ngFor let-group [ngForOf]="groups" let-groupIndex="index">
    <xvi-schema-form-group
      *ngIf="!(group.hiddenObs && (group.hiddenObs | async))"
      [group]="group"
      [hidden]="!(isFormExpanded(formConfig?.formKey) | async)"
      [dynamicWidgetsMap]="dynamicWidgetsMap"
      [attr.data-group-index]="groupIndex"
      [class.hidden]="!isActiveTab(groupIndex)"
      [defaultWidgetFamily]="defaultWidgetFamily"
      [attr.data-e2e-id]="'common-form-page' + formConfig?.formKey"
      #schemaFormGroup
    ></xvi-schema-form-group>
  </ng-template>
</ng-container>
